import { render, staticRenderFns } from "./wordlist.vue?vue&type=template&id=0ba3b58a"
import script from "./wordlist.vue?vue&type=script&lang=js"
export * from "./wordlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports